var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusStyle != '')?_c('v-chip',{staticClass:"table-label",style:(_vm.statusStyle),attrs:{"small":"","label":"","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[(_vm.icon !=='')?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.$t(_vm.statusText))+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }